var _path, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAscendex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5278_18425)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5278_18425",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 45
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1354 22.3224C44.1543 26.6087 42.9006 30.8043 40.5328 34.3787C38.165 37.9531 34.7895 40.7458 30.8331 42.4035C26.8767 44.0612 22.5171 44.5095 18.3057 43.6917C14.0942 42.874 10.2201 40.8269 7.17316 37.8093C4.12623 34.7917 2.04337 30.9392 1.18798 26.7389C0.332581 22.5386 0.74307 18.1793 2.36753 14.2121C3.99199 10.2449 6.75747 6.84807 10.3142 4.45118C13.871 2.05429 18.0593 0.764978 22.3495 0.7463C28.1022 0.721255 33.6293 2.98033 37.7149 7.0266C41.8005 11.0729 44.11 16.5749 44.1354 22.3224Z",
    fill: "#8DC63F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5278_18425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0454 24.463L35.3592 14.1492V29.9568H19.5502L17.8005 27.0096L11.4155 33.3332H36.5675C37.1251 33.3332 37.6598 33.1117 38.0541 32.7174C38.4484 32.3232 38.67 31.7884 38.67 31.2308V11.2131C38.6703 10.7971 38.5471 10.3903 38.3161 10.0443C38.0851 9.69835 37.7566 9.42872 37.3723 9.26948C36.988 9.11025 36.565 9.06861 36.157 9.14984C35.749 9.23107 35.3743 9.4315 35.0802 9.72578L25.0565 19.7497L25.0454 24.463Z",
    fill: "#7637BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0499 29.9579V16.8624C25.0498 16.4013 24.9129 15.9505 24.6566 15.5672C24.4004 15.1839 24.0362 14.8851 23.6102 14.7087C23.1842 14.5322 22.7155 14.4861 22.2632 14.576C21.8109 14.6659 21.3955 14.8878 21.0694 15.2138L2.91748 33.3658H11.4199L14.7922 29.9948H11.3393L21.7843 19.5499V29.9579H25.0499Z",
    fill: "#2C2236"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5278_18425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.35,
    height: 43.35,
    fill: "white",
    transform: "translate(0.75 0.75)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscendex);
export default __webpack_public_path__ + "static/media/ascendex.5a6165b049c68996fafd4afd93ba4baa.svg";
export { ForwardRef as ReactComponent };